module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ec.30816374.png";